module.exports = __webpack_public_path__ + "img/pd_T4.5.2.3de0bf65.png";